// Version : 0.0.1
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';

import RecurringDepositProposalActionTypes from './recurring-deposit-proposal.types';
import {
	createNewRecurringDeposit,
	updateRecurringDeposit,
	fetchRecurringDeposit,
	getRecurringDeposit,
	deleteRecurringDeposit,
} from './recurring-deposit-proposal.service';

import {
	addRecurringDepositProposalSuccess,
	addRecurringDepositProposalFailure,
	addRecurringDepositProposalResponseChanged,
	updateRecurringDepositProposalSuccess,
	updateRecurringDepositProposalFailure,
	updateRecurringDepositProposalResponseChanged,
	getRecurringDepositProposalSuccess,
	getRecurringDepositProposalFailure,
	getRecurringDepositProposalResponseChanged,
	deleteRecurringDepositProposalSuccess,
	deleteRecurringDepositProposalFailure,
	deleteRecurringDepositProposalResponseChanged,
	fetchRecurringDepositProposalSuccess,
	fetchRecurringDepositProposalFailure,
	fetchRecurringDepositProposalResponseChanged,
} from './recurring-deposit-proposal.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';

/** ********************* START ADD RECURRING DEPOSIT PROPOSAL ******************** */
export function* createNewRecurringDepositProposal({ payload }: any) {
	try {
		const key = 'createRecurringDepositKey';
		const {
			areaId,
			branchId,
			totalAmount,
			loanOfficerId,
			loanProposalDate,
			meetUpLocation,
			memberMeetupLat,
			memberMeetupLong,
			meetUpTime,
			loanIndexType,
			loanType,
			userID,
			companyID,
			databaseName,
			funderName,
			memberLeadId,
			LoanIndexGroupMember,
		} = payload;

		const jsonData = {
			AreaID: areaId,
			BranchID: branchId,
			TotalLoanAmount: totalAmount,
			LoanOfficerID: loanOfficerId,
			LoanProposalDate: loanProposalDate,
			MeetUpLocation: meetUpLocation,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			MeetUpTime: meetUpTime,
			LoanIndexType: loanIndexType,
			LoanType: loanType,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			FunderName: funderName,
			MemberLeadID: memberLeadId,
			LoanIndexGroupMember: LoanIndexGroupMember,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createNewRecurringDeposit, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addRecurringDepositProposalFailure(responseData.data));
		} else {
			yield put(addRecurringDepositProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addRecurringDepositProposalFailure(error));
	}
}

export function* resetAddRecurringDepositProposalResponse() {
	yield put(addRecurringDepositProposalResponseChanged());
}

export function* onCreateRecurringDepositProposal() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_START,
		createNewRecurringDepositProposal,
	);
}

export function* onCreateRecurringDepositProposalResponseReset() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.ADD_RD_PROPOSAL_RESPONSE_RESET,
		resetAddRecurringDepositProposalResponse,
	);
}
/** ********************* END ADD RECURRING DEPOSIT PROPOSAL ******************** */

/** ********************* START UPDATE RECURRING DEPOSIT PROPOSAL ******************** */
export function* updateRecurringDepositProposal({ payload }: any) {
	try {
		const key = 'UpdateRecurringDepositProposalKey';
		const {
			loanIndexId,
			areaId,
			branchId,
			totalAmount,
			loanOfficerId,
			loanProposalDate,
			meetUpLocation,
			memberMeetupLat,
			memberMeetupLong,
			meetUpTime,
			loanIndexType,
			loanType,
			userID,
			companyID,
			databaseName,
			funderName,
			memberLeadId,
			LoanIndexGroupMember,
			productInvestorDetails,
		} = payload;

		const jsonData = {
			LoanIndexID: loanIndexId,
			AreaID: areaId,
			BranchID: branchId,
			TotalLoanAmount: totalAmount,
			LoanOfficerID: loanOfficerId,
			LoanProposalDate: loanProposalDate,
			MeetUpLocation: meetUpLocation,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			MeetUpTime: meetUpTime,
			LoanIndexType: loanIndexType,
			LoanType: loanType,
			CreatedUser: userID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			FunderName: funderName,
			MemberLeadID: memberLeadId,
			LoanIndexGroupMember: LoanIndexGroupMember,
			ProductInvestorDetails: productInvestorDetails,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateRecurringDeposit, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateRecurringDepositProposalFailure(responseData.data));
		} else {
			yield put(updateRecurringDepositProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateRecurringDepositProposalFailure(error));
	}
}

export function* resetUpdateRecurringDepositProposalResponse() {
	yield put(updateRecurringDepositProposalResponseChanged());
}

export function* onUpdateRecurringDepositProposal() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_START,
		updateRecurringDepositProposal,
	);
}

export function* onUpdateRecurringDepositProposalResponseReset() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.UPDATE_RD_PROPOSAL_RESPONSE_RESET,
		resetUpdateRecurringDepositProposalResponse,
	);
}
/** ********************* END UPDATE RECURRING DEPOSIT PROPOSAL ******************** */

/** ********************* START FETCH RECURRING DEPOSIT PROPOSAL ******************** */
export function* fetchRecurringDepositProposalData({ payload }: any) {
	try {
		const key = 'FetchRecurringDepositInfoKey';
		const { companyID, loanIndexID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			loanIndexID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchRecurringDeposit, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchRecurringDepositProposalFailure(responseData.data));
		} else {
			yield put(fetchRecurringDepositProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchRecurringDepositProposalFailure(error));
	}
}

export function* resetFetchRecurringDepositProposalResponse() {
	yield put(fetchRecurringDepositProposalResponseChanged());
}

export function* onFetchRecurringDepositProposalDetails() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_START,
		fetchRecurringDepositProposalData,
	);
}

export function* onFetchRecurringDepositProposalResponseReset() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.FETCH_RD_PROPOSAL_RESPONSE_RESET,
		resetFetchRecurringDepositProposalResponse,
	);
}
/** ********************* END FETCH RECURRING DEPOSIT PROPOSAL ******************** */

/** ********************* START GET RECURRING DEPOSIT PROPOSAL ******************** */
export function* getRecurringDepositProposalData({ payload }: any) {
	try {
		const key = 'GetRecurringDepositProposalKey';
		const {
			companyID,
			branchID,
			centerID,
			groupID,
			userID,
			userRole,
			userRoleID,
			userLevel,
			databaseName,
			inputSearch,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			UserID: userID,
			UserRole: userRole,
			LoginUserRoleID: userRoleID,
			Level: userLevel,
			DatabaseName: databaseName,
			SearchData: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getRecurringDeposit, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRecurringDepositProposalFailure(responseData.data));
		} else {
			yield put(getRecurringDepositProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRecurringDepositProposalFailure(error));
	}
}

export function* resetGetRecurringDepositProposalResponse() {
	yield put(getRecurringDepositProposalResponseChanged());
}

export function* onGetRecurringDepositProposalDetails() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_START,
		getRecurringDepositProposalData,
	);
}

export function* onGetRecurringDepositProposalResponseReset() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.GET_RD_PROPOSAL_RESPONSE_RESET,
		resetGetRecurringDepositProposalResponse,
	);
}
/** ********************* END GET RECURRING DEPOSIT PROPOSAL ******************** */

/** ********************* START DELETE RECURRING DEPOSIT PROPOSAL ******************** */
export function* deleteRecurringDepositProposalData({ payload }: any) {
	try {
		const key = 'DeleteRecurringDepositProposalKey';
		const { companyID, loanIndexID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			loanIndexID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteRecurringDeposit, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteRecurringDepositProposalFailure(responseData.data));
		} else {
			yield put(deleteRecurringDepositProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteRecurringDepositProposalFailure(error));
	}
}

export function* resetDeleteRecurringDepositProposalResponse() {
	yield put(deleteRecurringDepositProposalResponseChanged());
}

export function* onDeleteRecurringDepositProposalDetails() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_START,
		deleteRecurringDepositProposalData,
	);
}

export function* onDeleteRecurringDepositProposalResponseReset() {
	yield takeLatest(
		RecurringDepositProposalActionTypes.DELETE_RD_PROPOSAL_RESPONSE_RESET,
		resetDeleteRecurringDepositProposalResponse,
	);
}
/** ********************* END DELETE RECURRING DEPOSIT PROPOSAL ******************** */

export function* recurringDepositProposalSaga() {
	yield all([
		call(onCreateRecurringDepositProposal),
		call(onCreateRecurringDepositProposalResponseReset),
		call(onFetchRecurringDepositProposalDetails),
		call(onFetchRecurringDepositProposalResponseReset),
		call(onUpdateRecurringDepositProposal),
		call(onUpdateRecurringDepositProposalResponseReset),
		call(onGetRecurringDepositProposalDetails),
		call(onGetRecurringDepositProposalResponseReset),
		call(onDeleteRecurringDepositProposalDetails),
		call(onDeleteRecurringDepositProposalResponseReset),
	]);
}
